module.exports = __webpack_public_path__ + "img/max6.949f3686.png";